import { render, staticRenderFns } from "./CoreUserMenu.vue?vue&type=template&id=382bac42&scoped=true&"
import script from "./CoreUserMenu.vue?vue&type=script&lang=ts&"
export * from "./CoreUserMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CoreUserMenu.vue?vue&type=style&index=0&id=382bac42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bac42",
  null
  
)

export default component.exports